module.exports = __webpack_public_path__ + "assets/img/num-03-cbdca474.png";